import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DirectReporteeFBDetaitDTO } from 'src/app/dtos/DirectReporteeFBDetaitDTO';
import { UserDTO } from 'src/app/dtos/UserDTO';
import { MeetingNotesService } from 'src/app/services/meetingNotes/meeting-notes.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { NotesDialogComponent } from './notes-dialog/notes-dialog.component';
import { NotesEnum } from 'src/app/services/notes/NotesEnum';
import { NotesRefreshService } from 'src/app/services/notes/notesrefresh.service';
import { Subscription } from 'rxjs';
import { DeleteNoteConfirmationDialogComponent } from './delete-note-confirmation-dialog/delete-note-confirmation-dialog.component';
import { NewFeedbackGroupService } from 'src/app/services/new-feedback-group.service';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss'],
})
export class NotesComponent implements OnInit, OnDestroy {
  @Input() directReporteeId: string;
  @Input() selectedYear: string;
  allCmMeetingNotesList = [];
  allPntMeetingNotesList = [];
  allCapLeadMeetingNotesList = [];
  private subscription: Subscription;
  hasCmRights: boolean = false;
  directReporteeList: any;
  hasSuperAdminRights: boolean = false;
  hasOnlyHrRights: boolean = false;
  shouldShowPntNotes: boolean = false;

  constructor(
    public userDetailsService: UserDetailsService,
    public meetingNotesService: MeetingNotesService,
    private dialog: MatDialog,
    public toaster: ToastrService,
    private notesRefreshService: NotesRefreshService,
    public dialogRef: MatDialogRef<any>,
    public feedbackgroupservice: NewFeedbackGroupService
  ) {}

  ngOnInit(): void {
    this.hasSuperAdminRights = this.userDetailsService.hasRole([
      'ROLE_SUPER_ADMIN',
    ]);
    this.hasOnlyHrRights =
      this.userDetailsService.hasRole(['ROLE_HUMAN_RESOURCE']) &&
      !this.hasSuperAdminRights;
    this.hasCmRights = this.userDetailsService.hasRole(['ROLE_CAREER_MANAGER']);
    this.loadMeetingNotes();
    this.subscription = this.notesRefreshService.refresh$.subscribe(() => {
      this.loadMeetingNotes();
    });
    this.getAllReportee();
  }

  getAllReportee(): void {
    this.feedbackgroupservice
      .getdirectreporteebyyear(this.selectedYear)
      .subscribe((res) => {
        this.directReporteeList = res.body;
        const isReporteeOfHr = this.directReporteeList?.some(
          (reportee: any) => reportee.userId === this.directReporteeId
        );
        this.shouldShowPntNotes =
          this.hasSuperAdminRights || (this.hasOnlyHrRights && !isReporteeOfHr);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedYear'] && !changes['selectedYear'].isFirstChange()) {
      this.loadMeetingNotes();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  openAssignNotesDialogue(action: string, noteData?: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '50%';
    dialogConfig.height = '68%';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      directReporteeId: this.directReporteeId,
      selectedYear: this.selectedYear,
      noteData: noteData,
      action: action,
    };

    const dialogRef = this.dialog
      .open(NotesDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result.event == 'Closed') {
        } else {
          this.loadMeetingNotes(); // Refresh notes after add/edit
        }
      });
  }

  loadMeetingNotes(): void {
    const userId = this.directReporteeId;
    const currentYear = this.selectedYear;

    // Clear all previous lists immediately
    this.allCmMeetingNotesList = [];
    this.allPntMeetingNotesList = [];
    this.allCapLeadMeetingNotesList = [];

    this.meetingNotesService
      .getAllMeetingNotesByIdAndYear(userId, currentYear)
      .subscribe({
        next: (res) => {
          const allNotes = res.body || [];

          const filteredNotes = allNotes.filter(
            (note) => String(note.year) === String(currentYear)
          );

          this.allCmMeetingNotesList = filteredNotes.filter(
            (note) => note.noteType === NotesEnum.Career_Manager
          );

          this.allPntMeetingNotesList = filteredNotes.filter(
            (note) => note.noteType === NotesEnum.PnT_Buddy
          );

          this.allCapLeadMeetingNotesList = filteredNotes.filter(
            (note) => note.noteType === NotesEnum.Capability_Lead
          );
        },
        error: (err) => {
          console.error('Failed to load notes:', err);
        },
      });
  }

  openDeleteConfirmationDialog(noteId: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '450px';
    dialogConfig.height = '200px';
    dialogConfig.data = {
      title: 'Delete Note',
      message: 'Are you sure you want to delete the note?',
      noteId: noteId,
    };
    dialogConfig.panelClass = 'confirm-discard-dialog';

    const dialogRef = this.dialog.open(
      DeleteNoteConfirmationDialogComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.loadMeetingNotes();
      }
      // Else, do nothing — confirmation dialog just closes
    });
  }
}
